import { Button } from '@e2n/ui';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function KalenderWeekPicker() {
  const {
    store: {
      setCurrentEndOfWeek,
      setCurrentStartOfWeek,
      ui: {
        kalender: { currentEndOfWeek, currentStartOfWeek },
      },
    },
  } = useRotationsplanFeatureContext();

  function handlePrevKWClick() {
    setCurrentStartOfWeek(
      currentStartOfWeek.subtract(1, 'week').startOf('isoWeek'),
    );
    setCurrentEndOfWeek(
      currentStartOfWeek.subtract(1, 'week').endOf('isoWeek'),
    );
  }

  function handleNextKWClick() {
    setCurrentStartOfWeek(currentStartOfWeek.add(1, 'week').startOf('isoWeek'));
    setCurrentEndOfWeek(currentStartOfWeek.add(1, 'week').endOf('isoWeek'));
  }

  return (
    <div className="flex w-full items-center justify-between gap-2 bg-white p-2">
      <Button
        variant="icon"
        size="icon"
        className="text-neutrals-700 text-xl"
        onClick={handlePrevKWClick}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
      <div className="flex items-center justify-center text-sm font-semibold">
        KW {currentStartOfWeek.isoWeek()} (
        {`${currentStartOfWeek.format('DD.MM')} – ${currentEndOfWeek.format('DD.MM.YYYY')}`}
        )
      </div>
      <Button
        className="text-neutrals-700 text-xl"
        size="icon"
        variant="icon"
        onClick={handleNextKWClick}>
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    </div>
  );
}
